import Vue from 'vue';
import VueRouter from 'vue-router';
import 'leaflet/dist/leaflet.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import vuetify from './plugins/vuetify';
import VueTelInputVuetify from 'vue-tel-input-vuetify';
import VueApp from './App.vue';
import LoginPage from './components/pages/LoginPage.vue';
import { vueData } from './VueData';
import V2DashboardPage from './components/pages/V2DashboardPage.vue';
import V2StoreCreatePage from './components/pages/store-setup/V2StoreCreatePage.vue';
import V2StoreSetupPage from './components/pages/store-setup/V2StoreSetupPage.vue';
import V2MenuImportPage from './components/pages/store-setup/V2MenuImportPage.vue';
import { RouteConfig } from 'vue-router/types/router';
import VModal from 'vue-js-modal';
import { closeAllDynamicModals } from './lib/modals';
import { Icon } from 'leaflet';
import { LMap, LTileLayer, LMarker, LPolygon, LPopup } from 'vue2-leaflet';
import VTooltip from 'v-tooltip';
import RestaurantDashboard from './components/pages/RestaurantDashboard.vue';
import RestaurantsService from './api/services/restaurants.service';
import RestaurantCategories from './components/pages/RestaurantCategories.vue';
import RestaurantItems from './components/pages/RestaurantItems.vue';
import ImageUploader from 'vue-image-upload-resize';
import * as VueGoogleMaps from 'gmap-vue/dist/gmap-vue';
import VueGtag from 'vue-gtag';
import { i18n } from './plugins/i18n';
import RestaurantTables from './components/pages/RestaurantTables.vue';
import RestaurantFloorPlanPage from './components/pages/restaurant/tables/RestaurantFloorPlanPage.vue';
import { Globals } from './modules/Globals';
import { getEffectiveTier } from './utils/billing-entitlements.utils';
import RootPage from './components/pages/RootPage.vue';
import V2QrPage from './components/pages/qr/V2QrPage.vue';
import RestaurantSettings from './components/pages/RestaurantSettings.vue';
import AuthService from './api/services/auth.service';
import RestaurantRoot from './components/pages/RestaurantRoot.vue';
import VueSocketio from 'vue-socket.io-extended';
import BranchesService from './api/services/branches.service';
import PartnerNew from './components/pages/PartnerNew.vue';
import PartnerDashboard from './components/pages/PartnerDashboard.vue';
import RestaurantBranches from './components/pages/RestaurantBranches.vue';
import BranchSettings from './components/pages/BranchSettings.vue';
import ForgotPassword from './components/pages/ForgotPassword.vue';
import ResetPassword from './components/pages/ResetPassword.vue';
import RestaurantMembers from './components/pages/RestaurantMembers.vue';
import { PermissionType } from './enums/PermissionType';
import { IMember, MemberRole } from './interfaces/IMember';
import CatalogSettings from './components/pages/CatalogSettings.vue';
import PriceAdmin from './components/pages/PriceAdmin.vue';
import TicketSettings from './components/pages/TicketSettings.vue';
import 'leaflet/dist/images/marker-shadow.png';
import VerifyEmail from './components/pages/VerifyEmail.vue';
import MarketplaceLink from './components/pages/MarketplaceLink.vue';
import LanguagesService from './api/services/languages.service';
import { ILanguage } from './interfaces/ILanguage';
import ItemPicturesLookup from './components/pages/admin/ItemPicturesLookup.vue';
import V2OrdersStats from './components/pages/stats/v2/V2OrdersStats.vue';
import V2PaymentMethodsStats from './components/pages/stats/v2/V2PaymentMethodsStats.vue';
import {
  activateDateFnsLocale,
  dateFnsLocales,
} from './plugins/date-fns-locales';
import timeago from './plugins/timeago/index';
import V2ViewsStats from './components/pages/stats/v2/V2ViewsStats.vue';
import AdminDashboard from './components/pages/admin/AdminDashboard.vue';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import V2ProductsStats from './components/pages/stats/v2/V2ProductsStats.vue';
import V2ProductsSeriesStats from './components/pages/stats/v2/V2ProductsSeriesStats.vue';
import PaymentMethods from './components/pages/User/PaymentMethods.vue';
import { VueMaskDirective } from 'v-mask';
import IncomeDashboard from './components/pages/admin/IncomeDashboard.vue';
import AdminPaymentsDashboard from './components/pages/admin/AdminPaymentsDashboard.vue';
import UsersService from './api/services/users.service';
import CollectionsPage from './components/pages/User/CollectionsPage.vue';
import OrderEmail from './components/pages/order-email/OrderEmail.vue';
import StickerManager from './components/pages/extras/StickerManager.vue';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import { createPinia, PiniaVuePlugin } from 'pinia';
import RestaurantCajas from './components/pages/RestaurantCajas.vue';
import { useRestaurant } from './composition/use-restaurant';
import PageCajaV2 from './components/pages/caja/PageCajaV2.vue';
import RestaurantInvoicing from './components/pages/RestaurantInvoicing.vue';
import PageCustomers from './components/pages/customer/PageCustomers.vue';
import { useSocket } from './composition/use-socket';
import { useAuth } from './composition/use-auth';
import io from 'socket.io-client';
import V2DesignPage from './components/pages/design/V2DesignPage.vue';
import RestaurantPosGate from './components/pages/restaurant/pos-v2/RestaurantPosGate.vue';
import PosV2OrderPage from './components/pages/restaurant/pos-v2/PosV2OrderPage.vue';
import PosV2TablePage from './components/pages/restaurant/pos-v2/PosV2TablePage.vue';
import PosV2HistoryPage from './components/pages/restaurant/pos-v2/PosV2HistoryPage.vue';
import PageUserSettings from './components/pages/User/PageUserSettings.vue';
import V2PageCajasHistoric from './components/pages/stats/v2/V2PageCajasHistoric.vue';
import RestaurantStock from './components/pages/restaurant/stock/RestaurantStock.vue';
import RestaurantStockMovements from './components/pages/restaurant/stock/RestaurantStockMovements.vue';
import V2RestaurantMenuOptions from './components/pages/restaurant/menu/options/V2RestaurantMenuOptions.vue';
import V2CatalogPage from './components/pages/catalog/V2CatalogPage.vue';
import { redirectToMenuV2, requireMenuV2 } from './composition/use-menu-v2';
import { applyAssistantQueryOverride } from './composition/assistant/use-assistant-rollout';
import V2StockConsumptionStats from './components/pages/stats/v2/V2StockConsumptionStats.vue';
import V2RestaurantDashboardPage from './components/pages/V2RestaurantDashboardPage.vue';
import V2RestaurantCouponsPage from './components/pages/restaurant/V2RestaurantCouponsPage.vue';
import V2TipsStats from './components/pages/stats/v2/V2TipsStats.vue';
import PagePosDevices from './components/pages/pos-devices/PagePosDevices.vue';
import BillingReturn from './components/pages/BillingReturn.vue';
import PageClub from './components/pages/club/PageClub.vue';
import V2ReservationsPage from './components/pages/reservations/V2ReservationsPage.vue';
import V2PageDayClose from './components/pages/stats/v2/V2PageDayClose.vue';
import V2PageDaySummary from './components/pages/stats/v2/V2PageDaySummary.vue';
import V2PageCategorySales from './components/pages/stats/v2/V2PageCategorySales.vue';
import V2PageReportingCategories from './components/pages/V2PageReportingCategories.vue';
import { confirmReusedPageLeave, reusesPage } from './utils/navigation.utils';

// Avoid Vue warnings for GPTHelp web components (custom elements)
Vue.config.ignoredElements = [/^gpt-help/];

export class App {
  private vueApp: Vue;
  restaurantsService = new RestaurantsService();
  branchesService = new BranchesService();
  authService = new AuthService();
  languagesService = new LanguagesService();
  usersService = new UsersService();
  initTime = Date.now();
  restaurantHelper: ReturnType<typeof useRestaurant>;
  socketHelper: ReturnType<typeof useSocket>;
  authHelper: ReturnType<typeof useAuth>;

  constructor() {
    this.init();
  }

  async init() {
    this.initTime = Date.now();

    try {
      // Set initializing state
      vueData.setInitializing(true);
      vueData.setConnectionError(null);
      vueData.setInitializationError(null);

      // Load location data in background (non-critical)
      this.loadLocation().catch((e) =>
        console.error('Error loading location:', e)
      );

      // Load languages (critical)
      try {
        Globals.languages = await this.languagesService.getAll();
      } catch (error) {
        console.error('Error loading languages:', error);

        if (error.message === 'Network Error') {
          throw error;
        }
        // Use default language if this fails
        Globals.languages = [{ id: 'es', name: 'Español' } as ILanguage];
      }

      // Initialize socket
      Globals.socket = io(Globals.wsPath, {
        path: '/ws',
        transports: ['websocket'],
        secure: Globals.IsProduction,
        autoConnect: false,
      });
      Vue.use(VueSocketio, Globals.socket);

      // Try to get user authentication
      try {
        const user = await this.authService.getMe();
        if (user) vueData.setUser(user);
      } catch (e) {
        console.error('Error getting user', e);

        if (e.message === 'Network Error') {
          throw e;
        }
        // This is okay - user might not be logged in
      }

      await this.initializeVue();

      this.restaurantHelper = useRestaurant();

      // Successfully initialized
      vueData.setInitializing(false);

      // Hide the HTML loader with fade effect
      setTimeout(() => {
        const loader = document.getElementById('app-loader');
        if (loader) {
          loader.classList.add('fade-out');
          setTimeout(() => loader.remove(), 300);
        }
      }, 100);
    } catch (error) {
      console.error('Critical initialization error:', error);
      vueData.setInitializationError(error as Error);
      vueData.setConnectionError(error as Error);

      // Still try to initialize Vue to show error screen
      await this.initializeVue().catch(() => {
        // If Vue fails too, show the HTML error
        const errorDiv = document.getElementById('loader-error');
        if (errorDiv) {
          errorDiv.style.display = 'block';
        }
      });
    }
  }

  async loadLocation() {
    const locationData = await this.usersService.getLocation();
    vueData.locationData = locationData;
    vueData.country = locationData[2];
  }

  async initializeVue() {
    Vue.use(VueRouter);
    Vue.use(ImageUploader);
    Vue.use(VModal, {
      dynamic: true,
      dynamicDefaults: { transition: 'none' /*, pivotY: 1 */ },
    });
    Vue.use(timeago, {
      name: 'Timeago', // Component name, `Timeago` by default
      locale: i18n.locale,
      // We use `date-fns` under the hood; locales are registered lazily into
      // this shared registry when the app language changes.
      locales: dateFnsLocales,
    });
    void activateDateFnsLocale(i18n.locale);
    this.setupValidationRules();

    Vue.use(VTooltip);
    Vue.use(PerfectScrollbar);

    Vue.directive('mask', VueMaskDirective);

    Vue.use(VueGoogleMaps, {
      load: {
        key: 'AIzaSyBlL8eVA5HLi2gvW742ZlfsZOtjr_QcjYY',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        //v: '3.32',
      },

      //// If you intend to programmatically custom event listener code
      //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
      //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
      //// you might need to turn this on.
      // autobindAllEvents: false,

      //// If you want to manually install components, e.g.
      //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
      //// Vue.component('GmapMarker', GmapMarker)
      //// then set installComponents to 'false'.
      //// If you want to automatically install all the components this property must be set to 'true':
      installComponents: true,
    });

    Vue.component('l-map', LMap);
    Vue.component('l-tile-layer', LTileLayer);
    Vue.component('l-marker', LMarker);
    Vue.component('l-polygon', LPolygon);
    Vue.component('l-popup', LPopup);

    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      //iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png').default,
      //iconUrl: require('leaflet/dist/images/marker-icon.png').default,
      //shadowUrl: require('leaflet/dist/images/marker-shadow.png').default,
      iconRetinaUrl,
      iconUrl,
      shadowUrl,
    });

    Vue.use(VueTelInputVuetify, {
      vuetify,
    });

    /* tslint:disable:no-bitwise */
    const routes = <RouteConfig[]>[
      { path: '/', component: RootPage, meta: { allowsGuests: true } },
      {
        path: '/marketplaceLink',
        component: MarketplaceLink,
        meta: { allowsGuests: true, noMenus: true },
      },
      {
        path: '/login',
        component: LoginPage,
        meta: { allowsGuests: true, onlyGuests: true },
        props: vueData,
      },
      {
        path: '/forgot',
        component: ForgotPassword,
        meta: { allowsGuests: true, onlyGuests: true },
      },
      {
        path: '/reset',
        component: ResetPassword,
        meta: { allowsGuests: true, onlyGuests: true },
      },
      {
        path: '/verify',
        name: 'verify',
        component: VerifyEmail,
        meta: { allowsGuests: true },
      },
      {
        path: '/staff/lookup',
        name: 'lookup',
        component: ItemPicturesLookup,
        props: vueData,
        meta: { onlyAdmin: true },
      },
      {
        path: '/staff/dashboard',
        component: AdminDashboard,
        props: vueData,
        meta: { onlyAdmin: true },
      },
      {
        path: '/staff/income',
        component: IncomeDashboard,
        props: vueData,
        meta: { onlyAdmin: true },
      },
      {
        path: '/staff/payments',
        component: AdminPaymentsDashboard,
        props: vueData,
        meta: { onlyAdmin: true },
      },
      { path: '/dashboard', component: V2DashboardPage, props: vueData },
      // Case-sensitive: a live store has the slug `New`, served by `/:restaurantId`.
      {
        path: '/new',
        component: V2StoreCreatePage,
        caseSensitive: true,
        props: vueData,
        meta: { noMenus: true, pos: true, fullPage: true },
      },
      {
        path: '/billing/return',
        component: BillingReturn,
        props: vueData,
        meta: { noMenus: true },
      },
      { path: '/me/collections', component: CollectionsPage, props: vueData },
      { path: '/me/settings', component: PageUserSettings, props: vueData },
      { path: '/me/billing', component: PaymentMethods, props: vueData },
      {
        path: '/partner/new',
        name: 'newPartner',
        component: PartnerNew,
        props: vueData,
        beforeEnter: (to, from, next) => {
          if (vueData.user.isPartner) {
            next('/partner');
            return;
          }
          next();
        },
      },
      {
        path: '/partner',
        component: PartnerDashboard,
        props: vueData,
        beforeEnter: (to, from, next) => {
          if (!vueData.user.isPartner) {
            next('/partner/new');
            return;
          }
          next();
        },
      },
      {
        path: '/:restaurantId/menu',
        name: 'catalogMenu',
        component: V2CatalogPage,
        props: vueData,
        // Every member may look, like the classic Items and Categorías pages;
        // the page is read-only without catalog permissions (plan §5.17).
        meta: { viewport: true },
        beforeEnter: requireMenuV2,
      },
      {
        path: '/:restaurantId/categories',
        component: RestaurantCategories,
        props: vueData,
        beforeEnter: redirectToMenuV2,
      },
      {
        path: '/:restaurantId/items',
        component: RestaurantItems,
        props: vueData,
        beforeEnter: redirectToMenuV2,
      },
      {
        path: '/:restaurantId/categories/classic',
        component: RestaurantCategories,
        props: vueData,
      },
      {
        path: '/:restaurantId/items/classic',
        component: RestaurantItems,
        props: vueData,
      },
      {
        path: '/:restaurantId/menu/options',
        component: V2RestaurantMenuOptions,
        props: vueData,
      },
      {
        path: '/:restaurantId/menu/import',
        component: V2MenuImportPage,
        props: vueData,
        meta: {
          noMenus: true,
          pos: true,
          fullPage: true,
          permissions: PermissionType.CatalogManage,
        },
      },
      {
        path: '/:restaurantId/setup',
        component: V2StoreSetupPage,
        props: vueData,
        meta: {
          noMenus: true,
          pos: true,
          fullPage: true,
          permissions: PermissionType.CatalogManage,
        },
      },
      {
        path: '/:restaurantId/tables',
        component: RestaurantTables,
        props: vueData,
        meta: { minTier: 1, branchSelector: true },
      },
      {
        path: '/:restaurantId/tables/plan',
        component: RestaurantFloorPlanPage,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.TablesManage,
        },
      },
      {
        path: '/:restaurantId/cajas',
        component: RestaurantCajas,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StoreSettings,
        },
      },
      {
        path: '/:restaurantId/members',
        component: RestaurantMembers,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.UsersManage,
        },
      },
      {
        path: '/:restaurantId/branches',
        component: RestaurantBranches,
        props: vueData,
        meta: { minTier: 2, permissions: PermissionType.BranchSettings },
      },
      {
        path: '/:restaurantId/branches/new',
        component: BranchSettings,
        props: vueData,
        meta: { minTier: 2, permissions: PermissionType.BranchSettings },
      },
      {
        path: '/:restaurantId/branches/:branchId',
        component: BranchSettings,
        props: vueData,
        meta: { minTier: 2, permissions: PermissionType.BranchSettings },
      },
      {
        path: '/:restaurantId/stickers',
        component: StickerManager,
        props: vueData,
        meta: { minTier: 2, permissions: PermissionType.CatalogManage },
      },
      {
        path: '/:restaurantId/qr',
        component: V2QrPage,
        props: vueData,
        meta: { branchSelector: true, permissions: PermissionType.QrGenerate },
      },
      {
        path: '/:restaurantId/settings',
        component: RestaurantSettings,
        props: vueData,
        meta: { permissions: PermissionType.StoreSettings },
      },
      {
        path: '/:restaurantId/ticket',
        component: TicketSettings,
        props: vueData,
        meta: {
          minTier: 1,
          permissions: PermissionType.BranchSettings,
          branchSelector: true,
        },
      },
      {
        path: '/:restaurantId/invoicing',
        component: RestaurantInvoicing,
        props: vueData,
        meta: {
          minTier: 2,
          permissions: PermissionType.BranchSettings,
          branchSelector: true,
        },
      },
      {
        path: '/:restaurantId/catalog/settings',
        component: CatalogSettings,
        props: vueData,
        meta: { permissions: PermissionType.CatalogManage },
      },
      {
        path: '/:restaurantId/emails',
        component: OrderEmail,
        props: vueData,
        meta: {
          permissions: PermissionType.BranchSettings,
          branchSelector: true,
        },
      },
      {
        path: '/:restaurantId/customers',
        component: PageCustomers,
        props: vueData,
        meta: {
          permissions: PermissionType.OrdersManage,
          branchSelector: true,
        },
      },
      {
        path: '/:restaurantId/coupons',
        component: V2RestaurantCouponsPage,
        props: vueData,
        meta: {
          permissions: PermissionType.StoreSettings,
          branchSelector: true,
        },
      },
      {
        path: '/:restaurantId/club',
        component: PageClub,
        props: vueData,
        meta: {
          minTier: 1,
          permissions: PermissionType.ClubManage | PermissionType.ClubTopup,
        },
      },
      {
        path: '/:restaurantId/reservations',
        name: 'restaurantReservations',
        component: V2ReservationsPage,
        props: vueData,
        meta: {
          minTier: 2,
          branchSelector: true,
          permissions:
            PermissionType.ReservationsManage |
            PermissionType.ReservationsSettings,
          pos: true,
        },
      },
      {
        path: '/:restaurantId/pos-devices',
        component: PagePosDevices,
        props: vueData,
        meta: {
          permissions: PermissionType.StoreSettings,
        },
      },
      {
        path: '/:restaurantId/design',
        component: V2DesignPage,
        meta: { permissions: PermissionType.StoreSettings, viewport: true },
      },
      {
        path: '/:restaurantId/catalog/prices',
        component: PriceAdmin,
        props: vueData,
        meta: { minTier: 1, permissions: PermissionType.CatalogManage },
      },
      {
        // Unified orders history (same component as /pos/history, content
        // layout via route meta — no `pos` flag here).
        path: '/:restaurantId/orders',
        component: PosV2HistoryPage,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.OrdersHistoric,
        },
      },
      {
        path: '/:restaurantId/caja',
        component: PageCajaV2,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.CajaManage,
          cajaSelector: true,
        },
      },
      {
        path: '/:restaurantId/pos',
        alias: '/:restaurantId/realtime',
        name: 'restaurantPos',
        component: RestaurantPosGate,
        props: vueData,
        meta: {
          minTier: 1,
          permissions: PermissionType.OrdersManage,
          pos: true,
        },
      },
      {
        path: '/:restaurantId/pos/order',
        name: 'restaurantPosOrder',
        component: PosV2OrderPage,
        props: vueData,
        meta: {
          minTier: 1,
          permissions: PermissionType.OrdersManage,
          pos: true,
        },
      },
      {
        // OrdersManage (not OrdersHistoric) on purpose: POS operators need
        // history for lookups/reprints. Server-side caja restrictions apply
        // to the orders tabs (the Mesas tab is deliberately caja-unrestricted,
        // like the session-detail endpoint).
        path: '/:restaurantId/pos/history',
        name: 'restaurantPosHistory',
        component: PosV2HistoryPage,
        props: vueData,
        meta: {
          minTier: 1,
          permissions: PermissionType.OrdersManage,
          pos: true,
        },
      },
      {
        path: '/:restaurantId/pos/table/:tableId',
        name: 'restaurantPosTable',
        component: PosV2TablePage,
        props: vueData,
        meta: {
          minTier: 1,
          permissions: PermissionType.OrdersManage,
          pos: true,
        },
      },
      {
        path: '/:restaurantId/stock/items',
        component: RestaurantStock,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.CatalogManage,
        },
      },
      {
        path: '/:restaurantId/stock/movements',
        component: RestaurantStockMovements,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.CatalogManage,
        },
      },
      {
        path: '/:restaurantId/dashboard2',
        name: 'oldRestaurantDashboard',
        component: RestaurantDashboard,
        props: vueData,
      },
      {
        path: '/:restaurantId/dashboard',
        name: 'restaurantDashboard',
        component: V2RestaurantDashboardPage,
        props: vueData,
      },
      {
        path: '/:restaurantId/stats/orders',
        component: V2OrdersStats,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/paymentMethods',
        component: V2PaymentMethodsStats,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/views',
        component: V2ViewsStats,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/products',
        component: V2ProductsStats,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/productsSeries',
        alias: '/:restaurantId/stats/products-daily',
        component: V2ProductsSeriesStats,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/cajas',
        component: V2PageCajasHistoric,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/stock-consumption',
        component: V2StockConsumptionStats,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/tips',
        component: V2TipsStats,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/day-close',
        component: V2PageDayClose,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/day-summary',
        component: V2PageDaySummary,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/stats/categories',
        component: V2PageCategorySales,
        props: vueData,
        meta: {
          minTier: 1,
          branchSelector: true,
          permissions: PermissionType.StatisticsView,
        },
      },
      {
        path: '/:restaurantId/catalog/reporting-categories',
        component: V2PageReportingCategories,
        props: vueData,
        meta: { minTier: 1, permissions: PermissionType.CatalogManage },
      },
      { path: '/:restaurantId', component: RestaurantRoot, props: vueData },
    ];
    /* tslint:enable:no-bitwise */

    const router = new VueRouter({
      base: Globals.basePath,
      mode: 'history',
      routes,
    });

    Vue.use(
      VueGtag,
      {
        //config: { id: "UA-171078765-2" }
        bootstrap: false,
      },
      router
    );

    Vue.use(VueTelInputVuetify, {
      vuetify,
    });

    this.setupI18n(router);

    window.addEventListener('resize', () => {
      vueData.windowWidth = window.innerWidth;
    });

    Vue.use(PiniaVuePlugin);
    const pinia = createPinia();

    this.registerInterceptors(router);

    let app = (this.vueApp = new Vue({
      i18n,
      router,
      vuetify,
      el: '#app',
      render: (h) => h(VueApp, { props: vueData }),
      data: vueData,
      pinia,
    }));

    this.socketHelper = useSocket(true, Globals.socket);

    vueData.init();
  }

  /**
   * Dynamic modals render in the global <modals-container>, outside the
   * routed view, so navigation alone never unmounts them. They are
   * restaurant-scoped (currency, branch and role come from the stores), so
   * the route guard dismisses them in the same tick it replaces or clears
   * that context; otherwise they re-render against null state (Sentry
   * BISTRIFY-ADMIN-2B). vueApp is unset only during the initial navigation,
   * which runs inside `new Vue()` before any restaurant is loaded.
   */
  private dismissRestaurantModals() {
    if (this.vueApp) closeAllDynamicModals(this.vueApp);
  }

  private registerInterceptors(router: VueRouter) {
    router.beforeEach(async (to, from, next) => {
      // `?assistant=on|off|default` works on any route (plan §9.1).
      const assistantOverride = applyAssistantQueryOverride(to.query);
      if (assistantOverride.stripped) {
        next({
          path: to.path,
          query: assistantOverride.query,
          hash: to.hash,
          replace: true,
        });
        return;
      }

      if (!to.meta.allowsGuests && !vueData.user) {
        next({
          path: '/login',
          query: { redirect: to.fullPath },
        });
        return;
      } else if (to.meta.onlyGuests && vueData.user) {
        next('/dashboard');
        return;
      } else if (to.meta.onlyAdmin && (!vueData.user || !vueData.user.admin)) {
        next('/dashboard');
        return;
      }

      if (to.params.hasOwnProperty('restaurantId')) {
        const stringId = to.params.restaurantId;
        if (!vueData.restaurant || vueData.restaurant.stringId !== stringId) {
          // Another store on the same page (`/a/setup` → `/b/setup`): the page
          // is reused, so its beforeRouteLeave never runs, and the swap below
          // would drop the setup page's pending saves. It confirms here.
          if (
            vueData.restaurant &&
            reusesPage(to, from) &&
            !(await confirmReusedPageLeave())
          ) {
            next(false);
            return;
          }
          try {
            const restaurant = await RestaurantsService.getFullRestaurantBySlug(
              stringId
            );
            const branches = restaurant.branches!;
            // Sort branches by index DESC
            branches.sort((a, b) => b.index - a.index);

            let role = await this.restaurantsService.getMember(
              restaurant.id,
              vueData.user.id
            );
            if (!role) {
              if (!vueData.user.admin) {
                throw new Error('Not authorized');
              } else {
                role = {
                  branches,
                  restaurant,
                  allBranches: true,
                  type: MemberRole.Admin,
                  user: vueData.user,
                } as IMember;
              }
            } else {
              if (role.allBranches) role.branches = branches;
            }

            const settings = restaurant.settings!;

            if (vueData.restaurant) this.dismissRestaurantModals();
            vueData.setCurrentRestaurant(restaurant);
            vueData.setCurrentRestaurantSettings(settings);

            vueData.setBranches(role.branches, branches);
            vueData.setCurrentRole(role);

            let branch;
            if (Globals.hasLocalStorage()) {
              const bId = localStorage.getItem(`${restaurant.id}-branch`);
              if (bId) {
                branch = vueData.branches.find((value) => value.id === +bId);
              }
            }

            vueData.setCurrentBranch(
              branch || vueData.branches.filter((b) => b.active)[0] || null
            );
            await this.restaurantHelper?.reloadAll?.();
          } catch (e) {
            console.error('Store not found', e);
            next('/dashboard');
            return;
          }
        }
      } else {
        if (vueData.restaurant) {
          this.dismissRestaurantModals();
          vueData.setCurrentRestaurant(null);
          vueData.setCurrentRestaurantSettings(null);
          vueData.setCurrentRole(null);
          vueData.setCurrency(null);
          vueData.setBranches(null);
          vueData.setCurrentBranch(null);
          this.restaurantHelper?.clearAll();
        }
      }

      if (to.meta.minTier) {
        const restaurant = vueData.restaurant;
        const effectiveTier = getEffectiveTier(vueData.restaurant);
        const minTierRaw = Number(to.meta.minTier);
        const minTier = Number.isFinite(minTierRaw) ? minTierRaw : 0;

        if (minTier > effectiveTier) {
          next(
            restaurant
              ? `/${restaurant.stringId}/settings?tab=plan`
              : '/dashboard'
          );
          return;
        }
      }

      if (to.meta.permissions) {
        const role = vueData.role;
        if (
          role.type === MemberRole.Custom &&
          // tslint:disable-next-line:no-bitwise
          (to.meta.permissions & role.permissions) === 0
        ) {
          next(`/${vueData.restaurant.stringId}/dashboard`);
          return;
        }
      }

      next();
    });
  }

  private setupI18n(router: VueRouter) {}

  private setupValidationRules() {
    const thumbCache = {};
    Vue.prototype.$thumb = (filename: string) => {
      if (thumbCache[filename]) return thumbCache[filename];
      const parts = filename.split('.');
      thumbCache[filename] = `${parts[0]}_thumb.${parts[1]}`;
      return thumbCache[filename];
    };

    const cache = {};
    Vue.prototype.$rule = (rule: string) => {
      if (cache[rule]) return cache[rule];

      const ruleParts = rule.split('|');
      const rules = [];

      for (const part of ruleParts) {
        if (part === 'required')
          rules.push(
            (v) =>
              (typeof v !== 'undefined' && v !== null && v !== '') ||
              i18n.t('validation.fieldRequired')
          );
        else if (part.startsWith('min')) {
          const min = parseInt(part.substr(3), 10);
          rules.push(
            (v) =>
              !v ||
              v === '' ||
              v.length >= min ||
              i18n.t('validation.minChars', { amount: min })
          );
        } else if (part.startsWith('max')) {
          const max = parseInt(part.substr(3), 10);
          rules.push(
            (v) =>
              !v ||
              v === '' ||
              v.length <= max ||
              i18n.t('validation.maxChars', { amount: max })
          );
        } else if (part === 'username')
          rules.push(
            (v) =>
              !v ||
              v === '' ||
              /^[a-zñÑA-Z0-9_]+$/.test(v) ||
              i18n.t('validation.onlyAlphanumeric')
          );
        else if (part === 'email')
          rules.push(
            (v) =>
              !v ||
              v === '' ||
              /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                v
              ) ||
              i18n.t('validation.invalidEmail')
          );
        else if (part === 'number')
          rules.push(
            (v) =>
              !v ||
              v === '' ||
              /^[0-9\.]+$/.test(v) ||
              i18n.t('validation.onlyNumeric')
          );
        else if (part === 'allnumber')
          rules.push(
            (v) =>
              !v ||
              v === '' ||
              /^[0-9\.\-]+$/.test(v) ||
              i18n.t('validation.onlyNumeric')
          );
        else if (part === 'url')
          rules.push(
            (v) =>
              !v ||
              v === '' ||
              /^(http|https):\/\/[^ "]+$/.test(v) ||
              'Ingrese un link válido'
          );
        else if (part.startsWith('linesmax')) {
          const maxLines = parseInt(part.substr(8), 10);
          rules.push(
            (v) =>
              !v ||
              v.split('\n').length <= maxLines ||
              `Máximo ${maxLines} líneas`
          );
        }
      }

      cache[rule] = rules;

      return rules;
    };
  }
}
